// Tiền theo minor unit (K5): hiển thị / nhập bằng CHUỖI, không bao giờ qua số thực. `scale` = minorUnitScale của field.

export interface NumberSeparators {
  readonly group: string;
  readonly decimal: string;
}

/** Dấu phân cách của locale (vi: « . » nhóm, « , » thập phân; en: ngược lại). */
export function separatorsOf(locale: string): NumberSeparators {
  const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
  return { group: parts.find((p) => p.type === "group")?.value ?? ",", decimal: parts.find((p) => p.type === "decimal")?.value ?? "." };
}

/** "23500000", scale 0 ⇒ "23.500.000" (vi). "123456", scale 2 ⇒ "1,234.56" (en). */
export function formatMinor(minor: string, scale: number, sep: NumberSeparators): string {
  const neg = minor.startsWith("-");
  const digits = (neg ? minor.slice(1) : minor).replace(/^0+(?=\d)/, "").padStart(scale + 1, "0");
  const int = digits.slice(0, digits.length - scale).replace(/\B(?=(\d{3})+(?!\d))/g, sep.group);
  const frac = scale > 0 ? `${sep.decimal}${digits.slice(digits.length - scale)}` : "";
  return `${neg ? "-" : ""}${int}${frac}`;
}

/** Ngược lại của formatMinor; trả null khi không hợp lệ (quá số chữ số lẻ, ký tự lạ). */
export function parseMoney(text: string, scale: number, sep: NumberSeparators): string | null {
  const t = text.trim().replace(/\s/g, "");
  if (!t) return null;
  const neg = t.startsWith("-");
  const body = (neg ? t.slice(1) : t).split(sep.group).join("");
  const [int = "", frac = "", ...rest] = body.split(sep.decimal);
  if (rest.length || !/^\d*$/.test(int) || !/^\d*$/.test(frac) || (!int && !frac) || frac.length > scale) return null;
  const minor = `${int || "0"}${frac.padEnd(scale, "0")}`.replace(/^0+(?=\d)/, "");
  if (minor.length > 18) return null;
  return neg && minor !== "0" ? `-${minor}` : minor;
}
